import styled from "styled-components"
import { TABLET_MAX_WIDTH } from "@constants"

export const StyledArticleTitle = styled.h1`
  color: #252525;
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 3rem;
  letter-spacing: 0.8px;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    font-size: 28px;
    line-height: 31px;
    letter-spacing: 0.48px;
  }
`;


